// Reconnaissance du donateur (décision d'Avi, 30/09/2026) : APRÈS le code,
// on redemande la fiche au serveur AVEC le jeton de vérification — c'est la
// seule façon d'obtenir le nom, l'adresse et les contacts enregistrés. Sans
// jeton valable, le serveur ne dit que « on vous connaît déjà ».
//
// Partagé par les pages campagne, don, fête et Kiddouch.
import axios from "axios";
import { PUBLIC_API } from "./api";

/**
 * Fiche du donateur dont l'identité vient d'être prouvée, ou ``null``.
 *
 * ``contact`` doit être celui qui a servi à le reconnaître (``methode`` :
 * "email" | "phone") : c'est lui que le code a prouvé.
 */
export async function chargerFicheProuvee({ orgId, methode, contact, jeton }) {
  const valeur = (contact || "").trim();
  if (!orgId || !valeur || !jeton) return null;
  // Jeton dans un EN-TÊTE, pas dans l'adresse : l'adresse d'une requête
  // finit dans les journaux d'accès du serveur, pas les en-têtes.
  const r = await axios.get(`${PUBLIC_API}/campaigns/public/recognize-donor`, {
    params: {
      org_id: orgId,
      ...(methode === "phone" ? { phone: valeur } : { email: valeur }),
    },
    headers: { "X-Verification-Token": jeton },
  });
  const d = r.data || {};
  if (!d.found) return null;
  // Serveur d'avant la décision du 30/09 : pas d'« identity_verified », mais
  // l'adresse n'était renvoyée qu'avec un jeton valable.
  const prouvee = d.identity_verified === true
    || (d.identity_verified === undefined && Object.prototype.hasOwnProperty.call(d, "address"));
  return prouvee ? d : null;
}

/** Le nom saisi diffère-t-il de celui de la fiche (modification explicite) ? */
export function nomModifie(fiche, prenom, nom) {
  if (!fiche) return false;
  const pf = (fiche.first_name || "").trim();
  const nf = (fiche.last_name || "").trim();
  return Boolean((pf && pf !== (prenom || "").trim()) || (nf && nf !== (nom || "").trim()));
}

const normaliser = (v) => String(v || "").trim().toLowerCase();

/**
 * Champs nom FIGÉS après le code : le serveur ne remplace le nom d'une fiche
 * que si le code a prouvé l'email de CETTE fiche (``nom_modifiable``). Sinon
 * (code reçu par SMS sur un téléphone souvent familial), un nom déjà
 * enregistré n'est pas modifiable — le figer évite de laisser croire à une
 * correction qui ne serait pas enregistrée (le reçu fiscal garde le nom de
 * la fiche). Seulement quand le don sera bien rattaché à cette fiche : même
 * email que la fiche, ou fiche sans email ; avec un AUTRE email, le serveur
 * crée une nouvelle fiche et le nom saisi est libre.
 *
 * Retourne { first_name: bool, last_name: bool }.
 */
export function nomsFiges(fiche, email) {
  const aucun = { first_name: false, last_name: false };
  if (!fiche || fiche.nom_modifiable !== false) return aucun;
  const emailFiche = normaliser(fiche.email);
  if (emailFiche && emailFiche !== normaliser(email)) return aucun;
  return {
    first_name: Boolean(String(fiche.first_name || "").trim()),
    last_name: Boolean(String(fiche.last_name || "").trim()),
  };
}
